const getters = {
  sidebar: state => state.app.sidebar,
  language: state => state.app.language,
  size: state => state.app.size,
  device: state => state.app.device,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  nameEn: state => state.user.nameEn,
  introduction: state => state.user.introduction,
  status: state => state.user.status,
  roles: state => state.user.roles,
  setting: state => state.user.setting,
  permission_routers: state => state.permission.routers,
  addRouters: state => state.permission.addRouters,
  errorLogs: state => state.errorLog.logs,
  userId: state => state.user.userId,
  username: state => state.user.username,
  userIp: state => state.user.userIp,
  systemCode: state => state.user.systemCode,
  actionUrl: state => state.user.actionUrl,
  departmentId: state => state.user.departmentId,
  dding: state => state.user.dding,
  tagsList: state => state.tags.tagsList,
  showTip: state => state.app.showTip,
  meetingList: state => state.app.meetingList,
  departTree: state => state.app.departTree
}
export default getters
